import { ArrowUpRight, Github, Linkedin, Mail } from 'lucide-react';
import { profile } from '../data/resume';

export default function Hero() {
  return (
    <section id="about" className="hero">
      <div className="hero-grid">
        <div className="hero-content">
          <h1 className="hero-name">{profile.name}</h1>
          <p className="hero-role">{profile.title}</p>
          <p className="hero-subtitle">{profile.subtitle}</p>
          <p className="hero-summary">{profile.summary}</p>

          <div className="hero-links">
            <a href={profile.links.github} target="_blank" rel="noopener noreferrer" className="social-link">
              <Github size={18} strokeWidth={1.75} />
              <span>GitHub</span>
            </a>
            <a href={profile.links.linkedin} target="_blank" rel="noopener noreferrer" className="social-link">
              <Linkedin size={18} strokeWidth={1.75} />
              <span>LinkedIn</span>
            </a>
            <a href={`mailto:${profile.email}`} className="social-link">
              <Mail size={18} strokeWidth={1.75} />
              <span>Email</span>
            </a>
          </div>

          <div className="hero-meta">
            <span>{profile.location}</span>
            <span className="meta-dot" aria-hidden="true" />
            <a href={`mailto:${profile.email}`}>{profile.email}</a>
            <span className="meta-dot" aria-hidden="true" />
            <span>{profile.phone}</span>
          </div>
        </div>

        <div className="hero-visual">
          <div className="photo-frame">
            <img src={profile.photo} alt={profile.name} className="hero-photo" />
          </div>
          <div className="hero-card">
            <span className="hero-card-label">Currently</span>
            <p className="hero-card-text">
              Senior Engineer at <strong>Commvault</strong>, building backend and distributed systems for enterprise-scale data protection across Go, Python, and React.
            </p>
            <a
              href="#experience"
              className="hero-card-link"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('experience')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              View experience
              <ArrowUpRight size={16} strokeWidth={2} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
